export var Browsers;
(function (Browsers) {
    Browsers["Firefox"] = "firefox";
    Browsers["Chrome"] = "chrome";
    Browsers["Safari"] = "safari";
    Browsers["Edge"] = "msedge";
    Browsers["Opera"] = "opera";
    Browsers["IE"] = "msie";
    Browsers["SamsungBrowser"] = "samsungBrowser";
    Browsers["Chromium"] = "chromium";
})(Browsers || (Browsers = {}));
export var OS;
(function (OS) {
    OS["Linux"] = "linux";
    OS["MacOS"] = "mac";
    OS["Windows"] = "windows";
    OS["iOS"] = "ios";
    OS["Android"] = "android";
    OS["ChromeOS"] = "chromeos";
})(OS || (OS = {}));
